import { HttpHeaders } from '@angular/common/http';
import { LOCAL_STORAGE_KEYS } from '../core/constants';
import { SortDirection } from './sort-direction';

export class HttpUtils {

  public static createHeaders(includeAuthorizationHeader: boolean = true): HttpHeaders {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);
    const idToken     = localStorage.getItem(LOCAL_STORAGE_KEYS.ID_TOKEN);

    const headers: { [key: string]: string | string[] } = {};
    if (includeAuthorizationHeader && accessToken) {
      headers['Authorization'] = 'Bearer ' + accessToken;
    }
    if (idToken) {
      headers['X-Identity'] = idToken;
    }

    return new HttpHeaders(headers);
  }

  public static createHeadersWithoutAuthorization(): HttpHeaders {
    return this.createHeaders(false);
  }

  public static createSearchRequest(page: number, size: number, sortColumn: string, direction: SortDirection): { [param: string]: string } {
    return {
      page: String(page),
      size: String(size),
      sort: sortColumn,
      direction: direction
    };
  }
}
